module.exports = __webpack_public_path__ + "static/main1.b29a0717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/main1.jpg
// module id = 487
// module chunks = 35783957827783